import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { SplashScreenProvider } from 'src/providers/splash-screen.provider';

@Component({
    selector: 'rota-splash-screen',
    templateUrl: 'splash-screen.html',
    styleUrl: 'splash-screen.scss',
    standalone: false
})

export class SplashScreenComponent {

  get isShow$(): Observable<boolean> {
    return this.splash.show$;
  }

  get withLoading$(): Observable<boolean> {
    return this.splash.loading$;
  }

  constructor(
    private splash: SplashScreenProvider,
  ) { }
}